import {
  AssetCategoryEnum,
  AssetEntity,
  AssetPDFSubtype,
  AssetType,
} from 'src/modules/assets/types';

export const isMaterialAsset = (asset: AssetEntity): boolean => {
  return (
    isFabricMaterialAsset(asset) || isLeatherMaterialAsset(asset) || isSurfaceMaterialAsset(asset)
  );
};

export const isFabricMaterialAsset = (asset: AssetEntity): boolean => {
  return (
    (asset.type === AssetType.PDF &&
      asset.subtype &&
      asset.subtype === AssetPDFSubtype.FabricMaterial) ||
    asset.asset_category?.key === AssetCategoryEnum.Fabric
  );
};

export const isLeatherMaterialAsset = (asset: AssetEntity): boolean => {
  return (
    (asset.type === AssetType.PDF &&
      asset.subtype &&
      asset.subtype === AssetPDFSubtype.LeatherMaterial) ||
    asset.asset_category?.key === AssetCategoryEnum.Leather
  );
};

export const isSurfaceMaterialAsset = (asset: AssetEntity): boolean => {
  // root.material.surface.
  // root.material.surfaceo.
  // root.material.surfacee.
  return (
    (asset.type === AssetType.PDF &&
      [
        AssetPDFSubtype.SurfaceMaterial,
        AssetPDFSubtype.SurfaceEMaterial,
        AssetPDFSubtype.SurfaceOMaterial,
      ].includes(asset.subtype as AssetPDFSubtype)) ||
    asset.asset_category?.key === AssetCategoryEnum.Surface
  );
};
